export default __webpack_public_path__ + "static/media/icon_message_light.fdb0d4ab.svg";